var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm._m(0), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("关闭")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: _vm.print
    }
  }, [_vm._v("打印")])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sheet-content",
    attrs: {
      id: "print"
    }
  }, [_c("div", {
    staticClass: "sheet-title"
  }, [_vm._v(" 函证代垫费用收费通知单 ")]), _c("p", {
    staticClass: "to"
  }, [_vm._v(" 致：被审单位 ")]), _c("p", {
    staticClass: "text"
  }, [_vm._v(" 按照业务合同约定，现与贵方进行本次项目的函证代垫费用结算，本次函证代垫费用涉及的金额为：XXX元，本所将开具对应金额的发票，请按合同签订的指定账号汇款！ ")]), _c("p", {
    staticClass: "thanks"
  }, [_vm._v(" 致谢！ ")]), _c("div", {
    staticClass: "form"
  }, [_c("p", [_vm._v(" XXXX会计师事务所 ")]), _c("p", [_vm._v(" 2020年X月X日 ")])]), _c("div", {
    staticClass: "table"
  }, [_c("div", [_vm._v("函证费用明细如下")]), _c("table", {
    attrs: {
      width: "100%"
    }
  }, [_c("tr", [_c("th", [_vm._v(" 函证信息 ")]), _c("th", [_vm._v(" 发函物流信息 ")]), _c("th", [_vm._v(" 发函费用 ")]), _c("th", [_vm._v(" 回函物流信息 ")]), _c("th", [_vm._v(" 回函费用 ")])]), _c("tr", [_c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")])]), _c("tr", [_c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")])]), _c("tr", [_c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")])]), _c("tr", [_c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")])]), _c("tr", [_c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")])]), _c("tr", [_c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")]), _c("td", [_vm._v(" 1 ")])])])]), _c("div", {
    staticClass: "statistics"
  }, [_c("div", [_vm._v("本次结算发函费用合计：XXX 回函费用合计：XXX元")]), _c("div", [_vm._v("函证代垫费用总计：XXX元")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };